import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor(private http: HttpClient) {
  }

  getCurrentServerTime(): Observable<Date> {
    return this.http.get(`${environment.api.host}/utils/time`)
      .pipe(
        map(data => {
            const timeData = data as Record<string, number | string>;
            return new Date(timeData['timestamp'] as number);
          }
        )
      );
  }

}
